import React, { useState } from 'react';
import AppBar from "@mui/material/AppBar";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ResumenNewEvaluaciones from './ResumenNewEvaluaciones';
import Mtable_NewEvaluaciones from './Mtable_NewEvaluaciones';



const MainNewEvaluacion = (params) => {
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position="static" style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Evaluaciones" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    <Tab label="Resumen" style={{ color: "#ffffff" , padding: "3px 7px 3px"}}  />
                </Tabs>
            </AppBar>
            {value === 0 && <Mtable_NewEvaluaciones params={params} />}
            {value === 1 && <ResumenNewEvaluaciones />}
        </div>
    );
};

export default MainNewEvaluacion;